'use strict';
import isObject from 'lodash/isObject';
import {makeActionCreator} from '../../../core-utilities/redux';

const ASSIGN_USER = '@@app-model/ASSIGN_USER';
const ASSIGN_ORGANIZATION = '@@app-model/ASSIGN_ORGANIZATION';
const ASSIGN_ORGANIZATION_PROFILE = '@@app-model/ASSIGN_ORGANIZATION_PROFILE';
const ASSIGN_PROJECT = '@@app-model/ASSIGN_PROJECT';
const ASSIGN_ASSET = '@@app-model/ASSIGN_ASSET';
const ASSIGN_ASSET_PROJECT = '@@app-model/ASSIGN_ASSET_PROJECT';

/**
 *
 * @param user
 * @return {ReduxAction}
 */
export function assignUserToModel(user) {
  return {
    type: ASSIGN_USER,
    payload: {
      user: getInstance(user),
    },
  };
}
assignUserToModel.TYPE = ASSIGN_USER;

/**
 *
 * @return {ReduxAction}
 */
export const assignUserProfileToModel = makeActionCreator('@@app-mode', 'ASSIGN_USER_PROFILE');

/**
 *
 * @param organization
 * @return {ReduxAction}
 */
export function assignOrganizationToModel(organization) {
  return {
    type: ASSIGN_ORGANIZATION,
    payload: {
      organization: getInstance(organization),
    },
  };
}
assignOrganizationToModel.TYPE = ASSIGN_ORGANIZATION;

/**
 *
 * @param orgProfile
 * @return {ReduxAction}
 */
export function assignOrganizationProfileToModel(orgProfile) {
  return {
    type: ASSIGN_ORGANIZATION_PROFILE,
    payload: {
      orgProfile: getInstance(orgProfile),
    },
  };
}
assignOrganizationProfileToModel.TYPE = ASSIGN_ORGANIZATION_PROFILE;

/**
 *
 * @param project
 * @return {ReduxAction}
 */
export function assignProjectToModel(project) {
  return {
    type: ASSIGN_PROJECT,
    payload: {
      project: getInstance(project),
    },
  };
}
assignProjectToModel.TYPE = ASSIGN_PROJECT;

/**
 *
 * @param asset
 * @return {ReduxAction}
 */
export function assignAssetToModel(asset) {
  return {
    type: ASSIGN_ASSET,
    payload: {
      asset: getInstance(asset),
    },
  };
}
assignAssetToModel.TYPE = ASSIGN_ASSET;

/**
 *
 * @param assetProject
 * @return {ReduxAction}
 */
export function assignAssetProjectToModel(assetProject) {
  return {
    type: ASSIGN_ASSET_PROJECT,
    payload: {
      assetProject: getInstance(assetProject),
    },
  };
}
assignAssetProjectToModel.TYPE = ASSIGN_ASSET_PROJECT;

/**
 *
 * @param instance
 * @return {null}
 * Package Local - Not part of public module API
 */
export function getInstance(instance) {
  return isObject(instance) ? instance : null;
}



// WEBPACK FOOTER //
// ./src/js/app/model/actions/assignment.js